import sliderPic1 from "./slider_pic_1.svg";
import sliderPic2 from "./slider_pic_2.svg";
import sliderPic3 from "./slider_pic_3.svg";
import sliderPic4 from "./slider_pic_4.svg";
import sliderPic5 from "./slider_pic_5.svg";

import aboutBgImage from "./about_Background.jpg";
import blogPrevImage from "./blog_prev_img.png";
import serviceBgImage from "./service-bk-img.png";
import capitalGainsSummary from "./PK Capital Gains - Summary.png";
import capitalGainsDetailed from "./PK Capital Gains - Details.png";
import expenseReport from "./PK Expense Incurred.png";
import dividendReport from "./SD Dividend Received.png";
import financialLedger from "./PK Financial Ledger.png";

import openingStockOne from "./opening_stock_1.png";
import openingStockTwo from "./opening_stock_2.png";
import indianFlagImg from "./indian_flag.svg";
import apiImg1 from "./apiImg1.png";
import apiImg2 from "./apiImg2.png";
import apiImg4 from "./apiImg4.png";
import apiImg5 from "./apiImg5.png";
import currentholding from "./currentholding.png";
import borderDesign1 from "./border-design1.png";
import borderDesign2 from "./border-design2.png";
import homeImage from "./home-dashboard.jpg";
import aboutUs from "./aboutus.jpg";
import popper from "./popper.gif";
import portfolioAnalytics from "./portfolio-analytics.jpg";
import callToAction from "./call-to-action.jpg";
import keyFeatures from "./key-features.jpg";
import dataDriven from "./data-driven.jpg";
import logo from "./logo.png"
import currentHolding from "./currentholdingPage.PNG"
import i4investDashboard from "./i4investDashboard.PNG"
import eligibleHolding from "./eligibleholding.png"
import brokerdemat from "./brokerdemat.jpeg"
import tradeCn from "./trade_cn.jpeg"

export {
  logo,
  homeImage,
  keyFeatures,
  dataDriven,
  portfolioAnalytics,
  callToAction,
  aboutUs,
  sliderPic1,
  sliderPic2,
  sliderPic3,
  sliderPic4,
  sliderPic5,
  aboutBgImage,
  blogPrevImage,
  serviceBgImage,
  openingStockOne,
  openingStockTwo,
  indianFlagImg,
  apiImg1,
  apiImg2,
  apiImg4,
  apiImg5,
  capitalGainsSummary,
  capitalGainsDetailed,
  expenseReport,
  dividendReport,
  financialLedger,
  currentholding,
  borderDesign1,
  borderDesign2,
  popper,
  currentHolding,
  i4investDashboard,
  eligibleHolding,
  brokerdemat,
  tradeCn,
};
